import { Auth, Environment, Metadata, Plan } from '@workspaces/types'
import { UserPermissions } from '../permissions.manager.type'
import ResolverBasic from './resolver-basic'
import { isAdvanceOptionsEnabled } from '@/plan/metadata/metadata.helper'
/**
 * 📢 3 different types of roles:
 *    - Admin
 *    - Power User
 *    - User
 */
class PermissionResolver extends ResolverBasic implements UserPermissions {
  canUploadCustomPOIs(): boolean {
    return true
  }

  canEditAnyCustomPOIGroup(): boolean {
    const role = this.getRole()
    return role === Auth.Role.Admin
  }

  canSavePlan(plan: Plan.Plan): boolean {
    const planId = plan.id
    if (!planId) {
      return true
    }
    const isPlanPublic = plan.is_public
    if (isPlanPublic && this.getRole() === Auth.Role.Admin) {
      return true
    }

    const planOwner = plan.created_by
    if (this.getName() === planOwner) {
      return true
    }

    return false
  }

  canSharePlan(plan: Plan.Plan): boolean {
    const planOwner = plan.created_by
    if (plan.id && this.getName() === planOwner) {
      return true
    }
    if (plan.id && this.getRole() === Auth.Role.Admin) {
      return true
    }
    if (plan.id && plan.is_public) {
      return true
    }
    return false
  }

  canSavePlanAsPublic(): boolean {
    return true
  }

  canDeletePlan(plan: Plan.Plan): boolean {
    const planOwner = plan.created_by
    const isPlanPublic = plan.is_public
    if (isPlanPublic && this.getRole() === Auth.Role.Admin) {
      return true
    }

    return this.getName() === planOwner
  }

  canDeleteCustomGeoboundary(owner: string): boolean {
    return this.isOwnerOrAdmin(owner)
  }

  canDeleteCustomPOIGroup(owner: string): boolean {
    return this.isOwnerOrAdmin(owner)
  }

  canUpdateCustomPOIGroup(owner: string): boolean {
    return this.isOwnerOrAdmin(owner)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canAdminEditPlan(plan: Plan.Plan): boolean {
    return false
  }

  canShowWidgetUploadAssets(): boolean {
    return true
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canShowStats(meta: Metadata.AppMetadata): boolean {
    return false
  }

  canAccessCustomizationByCountry(
    metadata: Metadata.AppMetadata,
    environment: Environment.EnvironmentResolver,
  ): boolean {
    const isFeatureAvailable = isAdvanceOptionsEnabled(metadata, environment)
    const permissonsOk = this.isAdmin()
    return isFeatureAvailable && permissonsOk
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canChangePlanOwner(plan: Plan.Plan): boolean {
    return false
  }

  canSeeAllPlans(): boolean {
    return false
  }
}

export default PermissionResolver
